module.exports = __webpack_public_path__ + "img/8-7.ff3fea4b.png";